<template lang="pug">
.page 
    v-chart.chart(:option="chartOption" :autoresize="true")
</template>

<script>
import VChart, {THEME_KEY} from 'vue-echarts';

export default {
    data() {
        return {
            content: [],
            timer: null,
            chartOption: {
                
                grid: [
                    {height: '80%', top: '10%',  left: '55px', right: '0'},
                ], 
                tooltip: {
                    trigger: 'item',
                    formatter: function(params) {
                        if (params.data.change != undefined) {

                            return  `<div>${params.name}</div> <div>${params.data.code}</div> ${params.data.change}%`;
                        }
                        else {
                            return `${params.name}`;
                        }
                    },
                },
                series: [{
                    type: 'treemap',
                    sort: 'desc',
                    width: '100%',
                    height: '100%',
                    breadcrumb: {
                        show: true,
                        position: ['right', 'top'],

                    },
                    data: [],
                    label: {
                        show: true,
                        position: 'insideTopLeft',
                        fontSize: '100%',
                        formatter: function(params) {
                            if (params.data.change != undefined) {
                                // const baseSize = 12;
                                // const maxSize = 24;
                                // // 计算当前值占总和的百分比（0~1）
                                // const total = params.treeAncestors.reduce((sum, node) => sum + node.value, 0);
                                // const ratio = params.data.value / total;
                                // let size = 'big';
                                // if (ratio < 0.001) {
                                //     size = 'small';
                                // }
                                // else if (ratio < 0.004) {
                                //     size = 'medium';
                                // }

                                return  `{${params.data.font_size}|${params.name}\n${params.data.change}%}`;
                            }
                            else {
                                return `${params.name}`;
                            }
                        },
                        rich: {
                            large: {
                                fontSize: 14,
                            },
                            middle: {
                                fontSize: 10,
                            },
                            small: {
                                fontSize: 8,
                            },
                            none: {
                                fontSize: 0,
                            }
                        }
                    },
                    
                    upperLabel: {
                        show: true,
                        height: 20,
                        color: '#fff',
                    },
                    levels: [
                        {
                            itemStyle: {
                                borderColor: '#555',
                                borderWidth: 4,
                                gapWidth: 4
                            },
                            upperLabel: {
                                show: false,
                            },
                        },
                        {
                            itemStyle: {
                                borderColor: '#333',
                                borderWidth: 1,
                                gapWidth: 1
                            }
                        },
                        {
                            itemStyle: {
                                borderColor: '#333',
                                borderWidth: 1,
                                gapWidth: 1,
                                
                            },
                            label: {
                                fontSize: 8,
                            },
                            
                        },
                    ]
                }]
            }
        }
    },
    mounted() {
        this.getData();
    },
    created() {
        // 组件创建时启动定时器
        this.startTimer();
    },
    beforeDestroy() {
        // 组件销毁前清除定时器
        this.clearTimer();
    },
    methods: {
        startTimer() {
            this.clearTimer(); // 先清除旧定时器（避免重复创建）
            this.timer = setInterval(() => {
                this.getData();
            }, 6000);
        },
        clearTimer() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        getData() {
            this.$api.request('GET', 'marketdatamap', {})
            .then(res => {
                this.content = res.data;
            });
        }
    },
    watch: {
        content: {
            handler(newVal) {
                this.chartOption.series[0].data = newVal;
            },
            immediate: true
        }
    },
    
    // computed: {
    //     option() {
    //         return 
    //     }
    // },
    components: {
        VChart,
    }
}
</script>